const AIMANAGER_MODULE1_FILE_TITLE_OVERRIDES: Record<string, string> = {
  'raci_matrix_template.xlsx': 'RACI Matrix Template for Practical Assignment',
  'raci_matrix_completed.xlsx': 'Completed RACI Matrix for AI Implementation',
  'industry_kpi_worksheet.xlsx': 'Industry and KPI Selection Worksheet',
  'benchmark_kpis.xlsx': 'Industry KPI Benchmarks',
  'activity3_reflection.docx': 'Reflection Questions (Exercise 3)',
  'operating_model_longread.docx':
    'Longread: AI Implementation Operating Model',
  'independent_work_differences.xlsx': 'Operating Model Gap Analysis Template',
  'governance_frameworks_screencast.xlsx':
    'Governance Frameworks: Models, Stage-Gate, Example',
  'industry_cases_student_worksheet.xlsx':
    'Industry Analysis Worksheet: ML vs GenAI',
  'self_assessment_worksheet.docx':
    'Marsh McLennan Case Self-Assessment Questions',
  'final_analysis_reference.docx': 'Seminar Analysis and Conclusion',
  'ml_vs_genai_summary_table.xlsx':
    'When to Choose ML and When to Choose GenAI',
  'longread_ml_cv_genai.docx': 'Longread: Technology Map: ML/CV/GenAI',
  'comparison_table_template.xlsx': 'Comparison Table Template',
  'temperature_experiment_worksheet.xlsx': 'Temperature Experiment Worksheet',
  'temperature_slide.docx': 'Slide: What Is Temperature?',
  '\u0421\u0435\u043c\u0438\u043d\u0430\u0440 1.3.mp4': 'Seminar 1.3 - Video',
  '1-3-mp4.mp4': 'Seminar 1.3 - Video',
  'genai_value_map_reference.xlsx':
    'GenAI Value Map Reference and Key Takeaways',
  'genai_value_map_worksheet.xlsx':
    'GenAI Case Prioritization Worksheet for Your Business',
  'genai_value_map_data.xlsx': 'GenAI Value Map Data for Display',
  'workshop_case_study_worksheet.xlsx': 'Case Study Analysis Worksheet',
  'evaluation_criteria_screencast.xlsx': 'Screencast Evaluation Criteria',
  'mitigation_plan_template.xlsx':
    'Risk Mitigation Plan Template (3 Antipatterns)',
  'audit_checklist.xlsx': '10 Antipatterns Audit Checklist',
  'example_execution.xlsx': 'Example Execution Plan (No Drift Monitoring)',
  'aup_template.xlsx': 'AUP Adaptation Template',
  'aup_presentation_script.docx': 'Three-Minute AUP Presentation Script',
  'self_checklist.xlsx': 'Pre-Submission Self-Checklist',
  'blank_assessment_template.xlsx': 'Quick Data Readiness Assessment Template',
  'completed_example_chatbot.xlsx':
    'Completed Assessment Example: Support Chatbot',
  'checklist_display.xlsx': 'Data Readiness Checklist and Decision Matrix',
};

const CYRILLIC_PATTERN = /[\u0400-\u04ff]/;

const getFileName = (value?: string | null) => {
  if (!value) {
    return '';
  }

  return value.split('/').pop() ?? value;
};

export const getAiManagerModule1DisplayTitle = (
  sourceKeyOrName?: string | null,
  fallback?: string | null
) => {
  const fileName = getFileName(sourceKeyOrName);
  const override = AIMANAGER_MODULE1_FILE_TITLE_OVERRIDES[fileName];

  if (override) {
    return override;
  }

  if (fallback && !CYRILLIC_PATTERN.test(fallback)) {
    return fallback;
  }

  return fileName || fallback || '';
};
